import { Head, usePage } from "@inertiajs/react"
import { ForgotPasswordForm } from "../../features/auth/forgot-password/ForgotPasswordForm"
import type { SharedPageProps } from "../../types/shared"

type ForgotPasswordPageProps = {
  errors?: {
    email?: string[]
  }
  success?: boolean
  email?: string | null
}

export default function ForgotPasswordPage({ errors, success = false, email }: ForgotPasswordPageProps) {
  const { props } = usePage<SharedPageProps>()

  return (
    <>
      <Head title="Esqueci a senha" />
      <main className="relative flex min-h-svh flex-col items-center justify-center overflow-hidden bg-slate-950 px-4 py-12">
        {/* Background decorations */}
        <div className="pointer-events-none absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 h-80 w-80 rounded-full bg-brand-600/20 blur-3xl" />
          <div className="absolute -bottom-40 -left-40 h-80 w-80 rounded-full bg-brand-600/20 blur-3xl" />
        </div>

        {/* Grid pattern */}
        <div className="pointer-events-none absolute inset-0 opacity-30">
          <div className="h-full w-full bg-[linear-gradient(to_right,rgba(51,65,85,0.7)_1px,transparent_1px),linear-gradient(to_bottom,rgba(51,65,85,0.7)_1px,transparent_1px)] [background-size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)]" />
        </div>

        <div className="relative z-10">
          {props.flash.alert && (
            <p className="mb-4 rounded-xl border border-rose-500/40 bg-rose-900/30 px-3 py-2 text-sm text-rose-200">
              {props.flash.alert}
            </p>
          )}
          <ForgotPasswordForm errors={errors} success={success} email={email} />
        </div>
      </main>
    </>
  )
}

